import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine';
import { getDentalModelStructure } from 'Domain/Scene/Provider/DentalModelProvider';

/**
 * Récupère la structure du modèle dentaire
 * @returns {Object|null}
 */
export const getModelStructure = () => {
    const scene = threeEngine.getScene();
    if (!scene) return null;
    return getDentalModelStructure(scene);
};

/**
 * Change la visibilité d'un groupe d'items par leurs UUIDs
 * @param {Array<string>} itemUuids - Liste des UUIDs des items
 * @param {boolean} visible - État de visibilité souhaité
 */
export const toggleItemsVisibility = (itemUuids, visible) => {
    const scene = threeEngine.getScene();
    if (!scene) return;
    
    itemUuids.forEach(uuid => {
        const item = scene.getObjectByProperty('uuid', uuid);
        if (item) {
            item.visible = visible;
            item.userData.manualVisibility = true;
        }
    });
};

/**
 * Change la visibilité d'un seul item par son UUID
 * @param {string} itemUuid - UUID de l'item
 * @param {boolean} visible - État de visibilité souhaité
 */
export const toggleItemVisibilityByUuid = (itemUuid, visible) => {
    const scene = threeEngine.getScene();
    if (!scene) return;
    
    const item = scene.getObjectByProperty('uuid', itemUuid);
    if (item) {
        item.visible = visible;
        item.userData.manualVisibility = true;
    }
};

/**
 * Vérifie si un item est visible
 * @param {string} itemUuid - UUID de l'item
 * @returns {boolean}
 */
export const isItemVisible = (itemUuid) => {
    const scene = threeEngine.getScene();
    if (!scene) return false;
    
    const item = scene.getObjectByProperty('uuid', itemUuid);
    return item ? item.visible : false;
};
